// extracted by mini-css-extract-plugin
export default {"wrapper":"PasswordChecker_wrapper__zb4uS"};